import axios from 'axios';
import { isLoading, setError } from './globalActions';
import Api from '../Config';

export const getTiles = tiles => ({
  type: 'GET_TILES',
  tiles,
});

export const resetTiles = () => ({
  type: 'RESET_TILES',
  tiles: [],
  page: 0,
  scrollPosition: 0,
});

export const setPage = page => ({
  type: 'SET_PAGE',
  page,
});

export const tileCounterHack = () => ({
  type: 'TILE_COUNTER_HACK',
});

export const setScrollPosition = scrollPosition => ({
  type: 'SET_SCROLL_POSITION',
  scrollPosition,
});

export const fetchTiles = (lang, page) => (dispatch) => {
  dispatch(isLoading(true));
  axios.post(`${Api.base + lang}/${Api.tiles}`, { page }).then((response) => {
    const data = response.data;
    dispatch(getTiles(data));
    dispatch(isLoading(false));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};

export const fetchFilteredTiles = (lang, filter, page) => (dispatch) => {
  const newPage = (page + 1) || 1;
  dispatch(setPage(newPage));
  dispatch(isLoading(true));

  axios.post(`${Api.base + lang}/${Api.tiles}`, { filter, page: newPage }, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    const data = response.data;
    dispatch(getTiles(data));
    dispatch(isLoading(false));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};

export const fetchSearchededTiles = (lang, search, page) => (dispatch) => {
  const newPage = (page + 1) || 1;
  dispatch(setPage(newPage));
  dispatch(isLoading(true));

  axios.post(`${Api.base + lang}/${Api.search}`, { term: search, page: newPage }, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    const data = response.data;
    dispatch(getTiles(data));
    dispatch(isLoading(false));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/tileActions.jsx